var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumbs } from "@/components/common/Breadcrumbs";
import { EvaluateServiceButton } from "@/components/common/EvaluateServiceButton";
import { Container } from "@/components/common/Container";
import { PageTitle } from "@/components/common/PageTitle";
import { ProcessoInfo } from "@/components/common/ProcessoInfo";
import { VeiculoInfo } from "@/components/common/VeiculoInfo";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/Alert";
import { If } from "@/components/ui/If";
import { useStepperControl } from "@/hooks/useStepperControl";
import GatewayService from "@/services/api/GatewayService";
import { AlertTriangle } from "lucide-react";
import { useState } from "react";
import { DialogCrvDetails } from "../crv/details";
var BREADCRUMB_ITEMS = [
    {
        name: "Página Inicial",
        path: "https://portal.pi.gov.br/detran/",
    },
    {
        name: "Acompanhar Processo Veicular",
        path: "/",
        current: true,
    },
];
export function Processo() {
    var service = new GatewayService();
    var _a = useState(false), showCrv = _a[0], setShowCrv = _a[1];
    var _b = useStepperControl(), processo = _b.processo, veiculo = _b.veiculo, crv = _b.crv;
    var _c = useState(""), error = _c[0], setError = _c[1];
    return (_jsxs(Container, { children: [_jsx(Breadcrumbs, { pages: BREADCRUMB_ITEMS }), _jsx(PageTitle, { title: "Acompanhamento de Processo Veicular" }), _jsxs("div", __assign({ className: "w-full max-w-[856px] flex flex-col gap-2" }, { children: [_jsx(If, __assign({ condition: typeof (veiculo === null || veiculo === void 0 ? void 0 : veiculo.placa) === "string" }, { children: _jsx(VeiculoInfo, { serviceName: "Acompanhamento de Processo Veicular", data: veiculo }) })), _jsx(ProcessoInfo, { serviceName: "Acompanhamento de Processo Veicular", crv: crv, data: processo, handleShowCrv: setShowCrv, setError: setError })] })), _jsx(DialogCrvDetails, { serviceReturn: crv, service: service, showCrv: showCrv, setShowCrv: setShowCrv, setError: setError }), error && (_jsxs(Alert, __assign({ variant: "destructive", className: "w-full max-w-[856px] bg-red-100 border-0" }, { children: [_jsx(AlertTriangle, { className: "h-4 w-4" }), _jsx(AlertTitle, { children: "Aten\u00E7\u00E3o!" }), _jsx(AlertDescription, { children: error })] }))), _jsx(EvaluateServiceButton, {})] }));
}
